
import { defineComponent } from 'vue'
import DocumentCard from '@/components/DocumentCard.vue'

export default defineComponent({
  name: 'ViewMoreDocuments',

  components: {
    DocumentCard
  },

  data () {
    return {
      showMore: false,
      hideButton: true
    }
  },

  methods: {
    showMoreDocuments: function () {
      this.showMore = true
      this.hideButton = false
    }
  }

})
